import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromActions from './remoteConfig.actions';
import { RemoteConfigService } from '../service';

@Injectable()
export class RemoteConfigEffects {
  loadRemoteConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadRemoteConfig),
      switchMap(() =>
        this.remoteConfigService.getAllValues().pipe(
          switchMap((remoteConfig) => of(fromActions.loadRemoteConfigSuccess({ remoteConfig }))),
          catchError(() => of(fromActions.loadRemoteConfigFailure()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly remoteConfigService: RemoteConfigService
  ) {}
}
